import { render, staticRenderFns } from "./BambeeLogo.vue?vue&type=template&id=52f244eb"
import script from "./BambeeLogo.vue?vue&type=script&lang=js"
export * from "./BambeeLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports